<script setup>
import { ref, computed } from 'vue'
import { useUsersStore } from '../stores/users'
import { useI18n } from "vue-i18n";
import { CheckIcon } from '@heroicons/vue/24/outline';
import { GlobeAltIcon } from '@heroicons/vue/24/solid';

const usersStore = useUsersStore();
const isOpen = ref(false);
const { t } = useI18n();

const sessionLanguage = sessionStorage.getItem('language');
const languageCode = (sessionLanguage === 'en' || sessionLanguage === 'mne') ? sessionLanguage : 'mne';

sessionStorage.setItem('language', languageCode);

const selectedLanguage = ref(
  languageCode === 'en'
    ? { code: 'en', flag: '🇬🇧', label: "English" }
    : { code: 'mne', flag: '🇲🇪', label: "Crnogorski" }
);

const languages =  computed (() =>  [
  { code: 'mne', flag: '🇲🇪', label: "Crnogorski" },
  { code: 'en', flag: '🇬🇧', label: "English" },
]);

const changeLanguage = (lang) => {
  selectedLanguage.value = lang;
  usersStore.changeLanguage(lang.code);
  isOpen.value = false;
};
</script>

<template>
  <div class="relative w-40"> <button
      class="flex justify-center items-center w-full gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
      @click="isOpen = !isOpen"
    >
      <GlobeAltIcon class="w-5 h-5 text-gray-500"/>
      <span>{{ t("common.language") }}</span>
    </button>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <div
        v-if="isOpen"
        class="absolute right-0 mt-2 w-full origin-top-right bg-white border border-gray-200 rounded-md shadow-lg z-10 ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div class="py-1">
          <a
            v-for="lang in languages"
            :key="lang.code"
            href="#"
            class="flex items-center justify-between px-4 py-2 text-sm text-gray-700"
            :class="selectedLanguage.code === lang.code ? 'bg-gray-100 text-gray-900' : 'hover:bg-gray-100 hover:text-gray-900'"
            @click.prevent="changeLanguage(lang)"
          >
            <div class="flex items-center gap-3">
              <span class="text-lg">{{ lang.flag }}</span> <span>{{ lang.label }}</span>
            </div>
            <CheckIcon v-if="selectedLanguage.code === lang.code" class="w-5 h-5 text-indigo-600"/>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>